import { ContactsApp } from '@wix/ambassador-contacts-app/http';
import { BaseApiService } from './Base.api';

class ContactsApi extends BaseApiService {
  private readonly contactsApi = ContactsApp(this.baseUrl, {
    useRedAxios: true,
  }).ContactsServiceV4();

  public deleteContact(contactId: string) {
    return this.AuthenticatedService.deleteContact({
      contactId,
    });
  }

  private get AuthenticatedService() {
    return this.contactsApi({
      Authorization: this.instance,
    });
  }
}

export const contactsApi = new ContactsApi('/_api/contacts');
